module.exports = __webpack_public_path__ + "img/ring_r_s_null_0.5c703b6e.png";